import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import 'react-dates/lib/css/_datepicker.css';
import { Provider } from 'react-redux';
import { startSetEntry, startFetchDivisions, startFetchExpenseAccounts, startValidation, startFetchVendors, login, logout } from './actions';
import './styles/styles.scss';
import AppRouter, { history } from './routers/AppRouter';
import store from './store/configureStore';
import LoadingPage from './components/loading/LoadingPage';

const theme = createMuiTheme({
  palette: {
    primary: { main: '#00aa5c' },
    dangerous: { main: red[500] }
  },
});

const jsx = (
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <AppRouter />
    </MuiThemeProvider>
  </Provider>
);

let hasRendered = false;
const renderApp = () => {
  if (!hasRendered) {
    ReactDOM.render(jsx, document.getElementById('app'));
    hasRendered = true;
  }
};

ReactDOM.render(<MuiThemeProvider theme={theme}><LoadingPage /></MuiThemeProvider>, document.getElementById('app'));


store.dispatch(startValidation()).then((user) => {
  if (user) {
    store.dispatch(login(user));
      store.dispatch(startSetEntry({})).then(() => {
        store.dispatch(startFetchDivisions()).then(() => {
          store.dispatch(startFetchExpenseAccounts()).then(() => {
            store.dispatch(startFetchVendors()).then(() => {
           renderApp();
           if (history.location.pathname === '/') {
             history.push('/cashier');
           }
         });
       });
     });
   });
  } else {
    store.dispatch(logout());
    renderApp();
    history.push('/');
  }
}).catch((error) => {
  console.log(error);
});



// WEBPACK FOOTER //
// ./src/app.js